import { getData, postData } from '@/utils/http';
import config from '@/config';
export default {
  namespaced: true,
  state: {
    name: '',
    detailId: '',
    status: '',
    tableLoading: true,
    addLoading: false,
    activeItem: {},
    tableList: [],
    tableData: [],
    type: '',
    pageIndex: 1,
    total: 0,
    isVerify:false,
  },
  mutations: {
    CHANGE_ACTIVE_ITEM(state, item) {
       item.carInfo = JSON.parse(item.content); 
      state.activeItem = item;
    },
    CHANGE_DETAIL_ID(state, value) {
      state.detailId = value;
    },
    CHANGE_TABLE_LOADING(state, tableLoading) {
      state.tableLoading = tableLoading;
    },
    CHANGE_ADD_LOADING(state, addLoading) {
      state.addLoading = addLoading;
    },
    CHANGE_TABLE_DATA(state, data) {
      data.rows.forEach((ds) => {
        const temp = JSON.parse(ds.content);
        ds.carNum = temp.carNum;
        ds.driverNum = temp.driverNum;
        ds.desc = temp.desc;
      });
      state.tableList = data.rows;
      state.total = data.total;
    },

    CHANGE_SEARCH_COLL(state, changeData) {
      if (
        changeData['changeKey'] == 'orgId' &&
        typeof changeData['data'] != 'object'
      ) {
        state[changeData['changeKey']] = [changeData['data']];
      } else {
        state[changeData['changeKey']] = changeData['data'];
      }
    },
    CHANGE_TABLE_INDEX(state, value) {
      state.pageIndex = value;
    },
     CHANGE_IS_REVIEW(state, value) {
      state.isVerify = value;
    },
  },
  actions: {
    //获取列表
    getList({ commit, state }) {
      const queryParams = config.jsonToQueryParams({
        page: state.pageIndex,
        size: config.pageSize,
        name: state.name,
        status: state.status,
      });
      return new Promise((resolve) => {
        getData(`platform/trans/apply/page?${queryParams}`).then((res) => {
          if (res.state == 1) {
            commit('CHANGE_TABLE_DATA', res.data);
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    getDetail({ commit, state }) {
      return new Promise((resolve) => {
        getData(`platform/trans/apply/get/${state.detailId}`).then((res) => {
          if (res.state == 1) {
            commit('CHANGE_ACTIVE_ITEM', res.data);
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    handleExamine({}, data) {
      return new Promise((resolve) => {
        postData('platform/trans/apply/examine', data).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    //写入查询条件
    setSearchData({ commit }, changeData) {
      commit('CHANGE_SEARCH_COLL', changeData);
    },
    //修改分页
    setPageIndex({ commit }, value) {
      commit('CHANGE_TABLE_INDEX', value);
    },
    //修改添加loading
    changeAddLoading({ commit }, value) {
      commit('CHANGE_ADD_LOADING', value);
    },
    //修改添加loading
    changeListLoading({ commit }, value) {
      commit('CHANGE_TABLE_LOADING', value);
    },
  },
};
